import {
	InteractionOfferingDescriptionProps,
	OfferingSourceType,
} from "./types";
import { useStyles } from "./style";
import { Text } from "@fluentui/react-components";
import { useIntl } from "react-intl";

export const InteractionOfferingDescription = (
	props: InteractionOfferingDescriptionProps
) => {
	const style = useStyles();
	const intl = useIntl();

	const getTranslationText = () => {
		switch (props.actionType) {
			case OfferingSourceType.Fallback:
				return "Transfer.FallbackFrom";
			case OfferingSourceType.Transfer:
				return "Transfer.TransferFromAgent";
			case OfferingSourceType.Callback:
				return "Transfer.CallbackFrom";
			case OfferingSourceType.Park:
				return "Transfer.UnparkedFrom";
			default:
				return "";
		}
	};

	return (
		<div className={style.transferAgentName}>
			<Text
				align="center"
				weight="bold"
				block
				className={style.purpleText}
				truncate
				wrap={false}
				title={props.resourceName}
			>
				{intl.formatMessage(
					{
						id: getTranslationText(),
					},
					{ resourceName: props.resourceName }
				)}
			</Text>
		</div>
	);
};
